import React from "react";
import { Container, Row, Col } from "reactstrap";

function Introduzione() {
  return (
    <>
      <div className="section section-dark section-nucleo-icons">
        <Container>
          <Row>
            {/* Inizio del testo */}
            <Col lg="6" md="12">
              {/* Titolo */}
              <h2 className="title">Che cos'è Node.js?</h2>
              
              <br />
              
              {/* Descrizione */}
              <p className="description">
                E' un runtime JavaScript, ovvero un ambiente di esecuzione che permette di eseguire del codice JavaScript come un qualsiasi linguaggio di programmazione.
                Questo è stato realizzato in qaunto JavaScript nasce come un linguaggio web lato client che, pertanto può essere eseguito solo all’interno di un browser (ad esempio Google Chrome) invece attraverso Node.js JavaScript è stato trasformato in un linguaggio di programmazione vero e proprio come qualsiasi altro.
              </p>
            </Col>
            {/* Fine del testo */}

            {/* Inizio delle icone */}
            <Col lg="6" md="12">
              <div className="icons-container">
                <i className="nc-icon nc-atom" />
                <i className="nc-icon nc-layout-11" />
                <i className="nc-icon nc-badge" />
                <i className="nc-icon nc-zoom-split" />
                <i className="nc-icon nc-cloud-download-93" />
                <i className="nc-icon nc-html5" />
                <i className="nc-icon nc-cloud-upload-94" />
              </div>
            </Col>
            {/* Fine delle icone */}
          </Row>
        </Container>
      </div>{" "}
    </>
  );
}

export default Introduzione;
